import CommonModal from "./CommonModal";
import { Spinner } from "react-bootstrap";

export default function DeployConfirmModal({
  show,
  onClose,
  onConfirm,
  confirming,
}) {
  return (
    <CommonModal show={show} onClose={onClose}>
      <div className="modal-card-body p-3">
        <div className="modal-card-content">
          <div className="message-title mb-3">Confirm Deployment</div>
        </div>
        <div className="card-footer-box">
          <button onClick={onClose} className="btn-grey ms-auto me-3">
            Close
          </button>
          <button onClick={onConfirm} className="btn-black">
            {confirming ? <Spinner size="sm" /> : "Deploy"}
          </button>
        </div>
      </div>
    </CommonModal>
  );
}
